/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* createCampaignWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.CREATE_CAMPAIGN, workerSaga);
  yield takeLatest(ActionConstants.FETCH_CAMPAIGN_DETAIL, workerSaga);
  yield takeLatest(
    ActionConstants.FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN,
    workerSaga
  );
}
